import React from 'react';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Button } from '@mui/material';
import { HashLink } from 'react-router-hash-link';

const Root = styled('div')(({ theme }) => ({
  '& .bypass-blocks__list': {
    listStyleType: 'none',
  },

  '& .bypass-blocks__list-item': {
    position: 'absolute',
    textAlign: 'center',
    left: 0,
    top: '10px',
    width: '100%',
    zIndex: 1300,
  },

  '& .bypass-blocks__button': {
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '320px',
    },
  },

  // TODO: replace with daaas-ui "screen-reader-only"
  '& .bypass-blocks__sr-only': {
    position: 'absolute !important',
    left: '-10000px',
    top: 'auto',
    width: '1px',
    height: '1px',
    overflow: 'hidden',
  },
}));

export default function BypassBlocks() {
  const { t } = useTranslation();

  const [state, setState] = React.useState({
    mainFocused: null,
    footerFocused: null,
  });

  const handleMainFocus = () => {
    setState({ ...state, mainFocused: true });
  };

  const handleMainBlur = () => {
    setState({ ...state, mainFocused: false });
  };

  const handleFooterFocus = () => {
    setState({ ...state, footerFocused: true });
  };

  const handleFooterBlur = () => {
    setState({ ...state, footerFocused: false });
  };

  return (
    <Root>
      <ul className="bypass-blocks__list">
        <li className="bypass-blocks__list-item">
          <Button
            className={clsx('bypass-blocks__button', {
              'bypass-blocks__sr-only': !state.mainFocused,
            })}
            color="primary"
            variant="contained"
            onFocus={handleMainFocus}
            onBlur={handleMainBlur}
            component={HashLink}
            to="#main"
          >
            {t('skipMain')}
          </Button>
        </li>
        <li className="bypass-blocks__list-item">
          <Button
            className={clsx('bypass-blocks__button', {
              'bypass-blocks__sr-only': !state.footerFocused,
            })}
            color="primary"
            variant="contained"
            onFocus={handleFooterFocus}
            onBlur={handleFooterBlur}
            component={HashLink}
            to="#footer"
          >
            {t('skipFooter')}
          </Button>
        </li>
      </ul>
    </Root>
  );
}
